/// <reference types="@angular/localize" />

// Component Imports
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { WalmartUSComponent } from './app/walmart-us.component';
import { appConfig } from './app/walmart-us.config';

import { LicenseManager } from 'ag-grid-enterprise';
import { environment } from './environments/environment';
import { AgGridLicenseKey } from '@shared/config';

LicenseManager.setLicenseKey(AgGridLicenseKey);

if (environment.production) {
  enableProdMode();
}

await bootstrapApplication(WalmartUSComponent, appConfig).catch((err) => console.error(err));
